export default "__VITE_ASSET__Dcl9nfh9__"